<template>
  <modal
    name="moreInfo"
    transition="nice-modal-fade"
    height="auto"
    :maxWidth="600"
    width="90%"
    :adaptive="true"
    :top="50"
    :delay="100"
  >
    <div class="modal-container">
      <button class="close-button" @click="$modal.hide('moreInfo')">
        <a-icon type="close-circle" class="position-close" />
      </button>

     

      <div class="menu-content">
        <h2>Spesielle åpningstider</h2>

        
        <p>Juleaften: stengt <br> 1.juledag: Stengt <br> 2.juledag: Stengt
        </p>


        <button @click="$modal.hide('moreInfo')" class="blk-btn-modal">
          Lukk
        </button>


      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "RestaurantInfoModal",
  components: {},
  props: {
   
  },

  data() {
    return {
    
    };
  },
  computed: {
    
  },

  methods: {


  },
  created() {}
};
</script>

<style lang="scss">
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.icon-flex {
  display: flex;

  padding: 1em;
}

.icon-float:hover {
  margin-top: -8px;
}
.icon-float {
  transition: margin 0.2s ease-in-out;
  margin: 0 5px 0 5px;
}
.modal-container {
  height: 100%;
}

.close-button {
  position: absolute;
  top: 0%;
  right: 0;
}

.position-close {
  position: absolute;
  top: 0%;
  right: 0;
  font-size: 28px;
}

.menu-image {
  border-radius: 0 0 100px 100px;
  box-shadow: 0px 8px 5px -1px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: 0px 8px 5px -1px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 8px 5px -1px rgba(0, 0, 0, 0.25);
  object-fit: cover;
  max-height: 450px;
  width: 100%;
  @media (max-width: $mobile) {
    max-height: 300px;
  }
}

.menu-content {
  font-family: Bebas;
  text-align: center;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & p {
    font-size: 1rem;
    margin-bottom: 0;
    font-family: Roboto, sans-serif;
    padding: 0em 1em 0em 1em;
    line-height: 30px;
    @media (max-width: $mobile) {
      font-size: 13px;
    }
  }

  & .vue-numeric-input {
    margin-top: 5em;
  }

  & h3 {
    font-size: 19px;
    @media (max-width: $mobile) {
      margin-top: 15px;
    }
  }

  & h2 {
    font-size: 27px;
  }
}

.blk-btn-modal {
  width: 180px;
  margin: 1em 1em 1em 1em;
  padding: 18px;
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  font-family: Bebas;
  font-size: 18px;
  vertical-align: bottom;

  &.btn-pay {
    width: 100%;
  }

  &:hover {
    background: #000000 !important;
    color: #ffffff !important;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .image-container {
    max-height: 450px;
  }


}
</style>
